const SPLIT_IT_UNAVAILABLE_MESSAGES: Record<string, string> = {
  AlreadyFinanced:
    "One or more of these charges is already on a Split It plan and can't be split again.",
  NoActiveLease:
    "Split It isn't available because this home doesn't have an active lease.",
  NoAvailableLeaseCapacity:
    'These charges are more than you can split over the time left on your lease. Try selecting fewer items.',
  FinancedPrincipalBelowMinimum:
    'The amount left to split is too small to set up a plan.',
  FinalLeaseMonth:
    "There isn't enough time left on your lease to split these charges.",
  MonthToMonthWithoutFiniteEndDate:
    "Split It isn't available on month-to-month leases.",
  NotFinanceable: "One or more of the selected charges can't be split.",
  NoOpenPrincipal: "These charges don't have an open balance to split.",
  UnsupportedInstallments:
    "The selected number of months isn't available for these charges.",
};

const DEFAULT_SPLIT_IT_UNAVAILABLE_MESSAGE =
  'Split It is not available for the selected items.';

export function getSplitItUnavailableMessage(reason?: string | null): string {
  if (!reason) return DEFAULT_SPLIT_IT_UNAVAILABLE_MESSAGE;
  return SPLIT_IT_UNAVAILABLE_MESSAGES[reason] ?? reason;
}
